import { gql } from '@apollo/client/core'

export const SEARCH_CLINIC_CONTACTS_BY_NAME_QUERY = gql`
  query SearchClinicContactsByName($input: ClinicContactsSearchInput!) {
    searchClinicContacts(input: $input) {
      data {
        name
        phone
        email
        address
        suite
        city
        state
        zip
        kyriosId
      }
      totalCount
    }
  }
`
